<!--
 * @Author: cmchiu
 * @Date: 2022-03-31 17:15:19
 * @LastEditTime: 2022-08-11 18:05:42
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \campus2022\campus2022-ClientApp\src\layout\index.vue
 * 
-->
<template>
    <div class="app-layout">
        <!-- <app-header /> -->
        <app-main />
        <!-- <app-footer /> -->
    </div>
</template>

<script>
import { /* AppHeader, AppFooter, */ AppMain } from './components'

export default {
    name: 'AppLayout',

    components: { /* AppHeader, AppFooter, */ AppMain },
}
</script>
